/* "הוצאות לפי...": קטגוריות או עסקים. 6 הגדולים בבית, רשימה מלאה עם השוואה בחלון,
   ופירוט של שורה אחת עם הפעולות עצמן */
import { useState } from 'react';
import { S } from '../../domain/state.js';
import { fmt, wD } from '../../lib/format.js';
import { mNorm } from '../../lib/text.js';
import { cat } from '../../domain/categories.js';
import { filterActive, getTxSrc } from '../../domain/tx.js';
import { keyAdd, periodLabel, curKey } from '../../domain/periods.js';
import { Sheet, Seg } from '../../components/ui.jsx';
import { openModal, closeModal } from '../../app/nav.js';
import { UI, ls, setTxf } from '../../store/ui.js';
import { txfDefault } from '../../domain/txFilter.js';
import { navigate } from '../../app/nav.js';
import { Icon } from '../../components/Icon.jsx';
import { openEditTx } from '../transactions/EditTx.jsx';
import { openClassify } from './Classify.jsx';

const PALETTE = ['#c8603a', '#3a7c5e', '#d4a13a', '#5a8ca8', '#a85a8c', '#3a8c7c', '#7a6e64'];
const keyOf = (mode, t) => (mode === 'cat' ? cat('expense', t.cat).id || 'other' : mNorm(t.description || '') || '-');
const noun = (mode, plural) => (mode === 'cat' ? (plural ? 'קטגוריות' : 'קטגוריה') : plural ? 'עסקים' : 'עסק');

function totals(mode, k) {
  const tot = {}, cnt = {}, lbl = {};
  filterActive(S.tx.filter((t) => t.month === k && t.type === 'expense')).forEach((t) => {
    const x = keyOf(mode, t);
    tot[x] = (tot[x] || 0) + (Number(t.amount) || 0);
    cnt[x] = (cnt[x] || 0) + 1;
    if (!lbl[x]) lbl[x] = (t.description || '').trim();
  });
  return { tot, cnt, lbl };
}
function label(mode, k, cur) {
  if (mode === 'cat') { const c = cat('expense', k); return c.icon + ' ' + c.label; }
  return (cur && cur.lbl[k]) || k;
}
const color = (mode, k, i) => (mode === 'cat' ? cat('expense', k).color : PALETTE[i % PALETTE.length]);

function history(mode, viewKey) {
  const cur = totals(mode, viewKey);
  const prev = [1, 2, 3].map((q) => totals(mode, keyAdd(viewKey, -q)));
  const prevEmpty = !Object.keys(prev[0].tot).length;
  const stat = (k) => {
    const v = cur.tot[k] || 0, pv = prev[0].tot[k] || 0;
    const hist = prev.filter((p) => Object.keys(p.tot).length).map((p) => p.tot[k] || 0);
    const avg = hist.length ? hist.reduce((s, x) => s + x, 0) / hist.length : 0;
    return { k, v, pv, avg, n: cur.cnt[k] || 0 };
  };
  return { cur, prev, prevEmpty, stat };
}

/** ▲ אדום עלה, ▼ ירוק ירד, "כרגיל" עד 5% */
function Delta({ a, b, noData }) {
  if (noData) return <span style={{ color: 'var(--ink4)' }}>-</span>;
  if (!b) return a ? <span className="muted">חדש</span> : null;
  const d = Math.round((a / b - 1) * 100);
  if (Math.abs(d) < 5) return <span className="muted">כרגיל</span>;
  return <span style={{ color: d > 0 ? 'var(--red)' : 'var(--green)' }}>{d > 0 ? '▲ ' : '▼ '}{Math.abs(d)}%</span>;
}

export function Breakdown() {
  const [mode, setModeState] = useState(() => ls.get('pie_mode', 'cat'));
  const setMode = (m) => { ls.set('pie_mode', m); setModeState(m); };
  const cur = totals(mode, UI.viewKey);
  const rows = Object.keys(cur.tot).map((k) => ({ k, v: cur.tot[k] })).sort((a, b) => b.v - a.v);
  const total = rows.reduce((s, r) => s + r.v, 0);
  const otherV = mode === 'cat' ? cur.tot.other || 0 : 0;
  return (
    <div className="panel">
      <div className="row-b mb8">
        <div className="sec" style={{ margin: 0 }}>הוצאות לפי {mode === 'cat' ? 'קטגוריה' : 'עסק'}</div>
        <Seg value={mode} onChange={setMode} size="sm" options={[['cat', 'קטגוריות'], ['mer', 'עסקים']]} />
      </div>
      {!total ? <div className="empty-s">אין הוצאות בתקופה</div> : (
        <>
          <div style={{ fontSize: '.93rem', color: 'var(--ink2)', margin: '-4px 0 10px' }}>
            סה"כ <b style={{ color: 'var(--ink)' }}>{fmt(total)}</b> ב-{rows.length} {noun(mode, true)}
            {otherV / total > 0.15 && (
              <div onClick={() => openClassify()} className="clickable" style={{ marginTop: 8, padding: '9px 11px', borderRadius: 10, background: 'var(--gold-l)', color: 'var(--ink)', fontSize: '.9rem' }}>
                ⚠️ {Math.round((otherV / total) * 100)}% מההוצאות ב"אחר", ולכן החלוקה לא מדויקת. <b>סווג עכשיו ‹</b>
              </div>
            )}
          </div>
          <div className="pie-leg two">
            {rows.slice(0, 6).map((r, i) => {
              const pct = (r.v / total) * 100, col = color(mode, r.k, i);
              return (
                <div className="leg-row clickable" key={r.k} onClick={() => openDetail(mode, r.k, false)}>
                  <div className="leg-dot" style={{ background: col }} />
                  <span className="leg-name">{label(mode, r.k, cur)}</span>
                  <span className="leg-val">{pct < 1 ? '<1' : Math.round(pct)}%<span>{fmt(r.v)}</span></span>
                  <div className="leg-bar"><i style={{ width: Math.max(2, pct) + '%', background: col }} /></div>
                </div>
              );
            })}
            <button className="leg-more" onClick={() => openAll(mode)}>{rows.length > 6 ? 'כל ' + rows.length + ' ה' + noun(mode, true) : 'פירוט מלא'} · השוואה לחודשים קודמים</button>
          </div>
        </>
      )}
    </div>
  );
}

function openAll(mode) { openModal(() => <AllSheet mode={mode} />); }
function openDetail(mode, k, fromList) { openModal(() => <DetailSheet mode={mode} k={k} fromList={fromList} />); }

function AllSheet({ mode }) {
  const H = history(mode, UI.viewKey), ids = {};
  Object.keys(H.cur.tot).forEach((k) => (ids[k] = 1));
  // קטגוריות: גם כאלה שהיו בעבר. עסקים: רק מהתקופה הזו, אחרת הרשימה אינסופית
  if (mode === 'cat') H.prev.forEach((p) => Object.keys(p.tot).forEach((k) => (ids[k] = 1)));
  const rows = Object.keys(ids).map(H.stat).sort((a, b) => b.v - a.v || b.avg - a.avg);
  const total = rows.reduce((s, r) => s + r.v, 0);
  const isCur = UI.viewKey === curKey();
  const grid = { display: 'grid', gridTemplateColumns: '1fr 70px 70px', gap: '4px 10px' };
  return (
    <Sheet wide title={'הוצאות לפי ' + noun(mode)}>
      <div className="sub mb12">
        {periodLabel(UI.viewKey)} · סה"כ {fmt(total)} ב-{rows.filter((r) => r.v).length} {noun(mode, true)}.
        {isCur ? ' התקופה עוד לא נגמרה, ולכן ההשוואה לתקופות שלמות נוטה להיות נמוכה.' : ''}
      </div>
      <div style={{ ...grid, fontSize: '.82rem', color: 'var(--ink3)', padding: '0 2px 6px', borderBottom: '1px solid var(--border)' }}>
        <span>{noun(mode)}</span><span style={{ textAlign: 'left' }}>מול קודמת</span><span style={{ textAlign: 'left' }}>מול ממוצע</span>
      </div>
      {rows.map((r, i) => {
        const pct = total ? (r.v / total) * 100 : 0;
        return (
          <div key={r.k} className="clickable" onClick={() => openDetail(mode, r.k, true)} style={{ padding: '10px 2px', borderBottom: '1px solid var(--border)' }}>
            <div style={{ ...grid, alignItems: 'baseline' }}>
              <span className="ellipsis" style={{ fontSize: '.9rem', fontWeight: 600 }}>{label(mode, r.k, H.cur)}</span>
              <span className="nowrap" style={{ fontSize: '.86rem', textAlign: 'left' }}><Delta a={r.v} b={r.pv} noData={H.prevEmpty} /></span>
              <span className="nowrap" style={{ fontSize: '.86rem', textAlign: 'left' }}><Delta a={r.v} b={r.avg} /></span>
            </div>
            <div className="row-b" style={{ alignItems: 'baseline', marginTop: 3, fontSize: '.86rem', color: 'var(--ink3)' }}>
              <span>{r.n ? (r.n === 1 ? 'פעולה אחת' : r.n + ' פעולות') : 'אין פעולות בתקופה'}{r.avg ? ' · ממוצע ' + fmt(Math.round(r.avg)) : ''}</span>
              <span><b style={{ color: 'var(--ink)', fontSize: '.95rem' }}>{fmt(r.v)}</b> {pct ? (pct < 1 ? '<1' : Math.round(pct)) + '%' : ''}</span>
            </div>
            <div style={{ height: 4, borderRadius: 99, background: 'var(--surface2)', overflow: 'hidden', marginTop: 6 }}>
              <i style={{ display: 'block', height: '100%', width: Math.max(r.v ? 2 : 0, pct) + '%', background: color(mode, r.k, i), borderRadius: 99 }} />
            </div>
          </div>
        );
      })}
    </Sheet>
  );
}

function DetailSheet({ mode, k, fromList }) {
  const H = history(mode, UI.viewKey), s = H.stat(k);
  const txs = filterActive(S.tx.filter((t) => t.month === UI.viewKey && t.type === 'expense' && keyOf(mode, t) === k))
    .sort((a, b) => String(b.date).localeCompare(String(a.date)));
  const cell = { background: 'var(--surface2)', borderRadius: 12, padding: '10px 12px' };
  return (
    <Sheet title={label(mode, k, H.cur)}>
      {fromList && <button className="link" style={{ fontSize: '.93rem', paddingBottom: 10 }} onClick={closeModal}>→ חזרה לכל ה{noun(mode, true)}</button>}
      <div className="grid3 mb12">
        <div style={cell}><div style={{ fontSize: '.82rem', color: 'var(--ink2)' }}>בתקופה</div><div style={{ fontSize: '1.05rem', fontWeight: 800 }}>{fmt(s.v)}</div><div className="note">{s.n === 1 ? 'פעולה אחת' : s.n + ' פעולות'}</div></div>
        <div style={cell}><div style={{ fontSize: '.82rem', color: 'var(--ink2)' }}>תקופה קודמת</div><div style={{ fontSize: '1.05rem', fontWeight: 800 }}>{H.prevEmpty ? '-' : fmt(s.pv)}</div><div style={{ fontSize: '.82rem' }}><Delta a={s.v} b={s.pv} noData={H.prevEmpty} /></div></div>
        <div style={cell}><div style={{ fontSize: '.82rem', color: 'var(--ink2)' }}>ממוצע</div><div style={{ fontSize: '1.05rem', fontWeight: 800 }}>{s.avg ? fmt(Math.round(s.avg)) : '-'}</div><div style={{ fontSize: '.82rem' }}><Delta a={s.v} b={s.avg} noData={!s.avg && !s.v} /></div></div>
      </div>
      {txs.length ? txs.map((t) => {
        const c = cat('expense', t.cat);
        return (
          <div key={t.id} className="row-b clickable" onClick={() => openEditTx(t.id)} style={{ padding: '9px 2px', borderBottom: '1px solid var(--border)' }}>
            <div style={{ minWidth: 0 }}>
              <div className="ellipsis" style={{ fontSize: '.95rem', fontWeight: 600 }}>{mode === 'cat' ? t.description : wD(t.date)}</div>
              <div style={{ fontSize: '.86rem', color: 'var(--ink3)' }}>{mode === 'cat' ? wD(t.date) + (getTxSrc(t) === 'credit' ? ' · 💳' : ' · 🏦') : c.icon + ' ' + c.label}</div>
            </div>
            <b className="nowrap red" style={{ fontSize: '.9rem' }}>{fmt(t.amount)}</b>
          </div>
        );
      }) : <div className="empty-s">אין פעולות בתקופה</div>}
      <button className="ubtn ubtn-outline w100 mt12" onClick={() => showInTx(mode, k, label(mode, k, H.cur))}>
        <Icon name="list" size={17} />{mode === 'cat' ? 'הצג במסך הפעולות' : 'כל הפעולות בעסק הזה'}
      </button>
    </Sheet>
  );
}

/** מסך הפעולות, מסונן לקטגוריה או לעסק, באותה תקופה */
function showInTx(mode, k, name) {
  setTxf({ ...txfDefault(), sort: UI.txf.sort, ...(mode === 'cat' ? { cats: ['expense:' + k] } : { q: name, type: 'expense' }) });
  navigate('Tx');
}
